import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M22 12l-4-4v3H3v2h15v3l4-4z"
}), 'TrendingFlatSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/TrendingFlatSharp.js
// module id = 6927
// module chunks = 2